import { put, call, takeLatest, all, select } from "redux-saga/effects";
import { getScheduleForProvider, getVisitTypeAndLocationForProvider, getArrivalTime,saveQuestionsResponse,loadQuestionByVisitType, getEarliestScheduleForProvider, getProvidersList, getMonthlyAvailability, scheduleAppointment, createPatient, getResponseForMammoQuestions } from "../api/openSchedulingApi";
import * as types from "../constants/actionTypes";
import { logAPI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";

export default function* openSchedulingSaga() {
    yield takeLatest(types.OPEN_SCHEDULE_PROVIDER, handleOpenScheduleProvider);
    yield takeLatest(types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION, handleVisitTypeLocation);
    yield takeLatest(types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS, handleLoadQuestionByVisitType);
    yield takeLatest(types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS, handleMammogramAnswers);
    yield takeLatest(types.OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE, resetMammogramQuestionsCurrentResponse);
    yield takeLatest(types.OPEN_SCHEDULE_QUESTIONS_RESPONSE, handleMammogramQuestionsResponse);
    yield takeLatest(types.OPEN_SCHEDULE_EARLIEST, handleEarliestForProvider);
    yield takeLatest(types.OPEN_SCHEDULE_ARRIVAL_TIME, handleArrivalTimeForProvider);
    yield takeLatest(types.OPEN_SCHEDULE_PROVIDER_LIST, handleProviderList);
    yield takeLatest(types.OPEN_SCHEDULE_SCHEDULE, handleSchedule);
    yield takeLatest(types.OPEN_SCHEDULE_CREATE_PATIENT, handleCreate);
    yield takeLatest(types.OPEN_SCHEDULE_CREATE_AND_SCHEDULE, handleCreateAndSchedule);    
}

export function* handleVisitTypeLocation(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            yield put({ type: types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION_RUNNING });
            const visits = yield call(getVisitTypeAndLocationForProvider, payload.searchModel, payload.enableNewProviderSchedulingWorkflow);
            yield put({ type: types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION_SUCCESS, visits });
            logAPI("MBHWeb.Saga.OpenScheduling.GetVisitTypeAndLocationForProvider", start, null);
            if (payload.callback) {
                payload.callback(true, visits);
            }
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.GetVisitTypeAndLocationForProvider.Failure", start, null, error);
            yield all([
                put({ type: types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION_FAILED }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
            if (payload.callback) {
                payload.callback(false, error);
            }
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleMammogramAnswers(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const answers = yield call(getResponseForMammoQuestions, payload.searchModel, payload.token);
            yield put({ type: types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_SUCCESS, answers });
            logAPI("MBHWeb.Saga.OpenScheduling.getResponseForMammoQuestions", start, null);
        }
        catch (error) {
            console.error(error);
            yield put({ type: types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS_FAILURE});
            logAPI("MBHWeb.Saga.OpenScheduling.getResponseForMammoQuestions.Failure", start, null, error);
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* resetMammogramQuestionsCurrentResponse() {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const answers = null;
            yield put({ type: types.OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE_COMPLETED, answers });
            logAPI("MBHWeb.Saga.OpenScheduling.resetMammogramQuestionsCurrentResponse", start, null);
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.resetMammogramQuestionsCurrentResponse.Failure", start, null, error);
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleMammogramQuestionsResponse(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const response = yield call(saveQuestionsResponse, payload.searchModel, payload.token);
            yield put({ type: types.OPEN_SCHEDULE_QUESTIONS_RESPONSE_SUCCESS, response });
            logAPI("MBHWeb.Saga.OpenScheduling.saveQuestionsResponse", start, null);
            if (payload.callback) {
                payload.callback(true, response);
            }
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.saveQuestionsResponse.Failure", start, null, error);
            if (payload.callback) {
                payload.callback(false, error);
            }
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleLoadQuestionByVisitType(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const questions = yield call(loadQuestionByVisitType, payload.searchModel);
            yield put({ type: types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_SUCCESS, questions });
            logAPI("MBHWeb.Saga.OpenScheduling.loadQuestionByVisitType", start, null);
            if (payload.callback) {
                payload.callback(true, questions);
            }
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.loadQuestionByVisitType.Failure", start, null, error);
            yield all([
                put({ type: types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS_FAILURE }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
            if (payload.callback) {
                payload.callback(false, error);
            }
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleOpenScheduleProvider(payload) {
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        if (payload.searchModel.getEarliestSchedule) {
            // request earliest on all get schedule calls, to enable/disable calendar month navigation...
            // update: to unnecessarily call earliest schedule, the decision to call it or not is made at the component level thru this flag of getEarliesSchedule;
            //         for example, it's not necessary to make that call while the user is moving from one month to another.

            const earliestModel = {
                departmentId: payload.searchModel.departmentId,
                providerId: payload.searchModel.providerId,
                providerIdType: payload.searchModel.providerIdType,
                scheduleType: payload.searchModel.scheduleType,
                visitTypeId: payload.searchModel.visitTypeId
            };

            if (payload.searchModel.scheduleType === "DirectSchedule") {
                earliestModel.loginId = payload.searchModel.loginId;
                earliestModel.patientId = payload.searchModel.patientId;
                earliestModel.patientIdType = payload.searchModel.patientIdType;
                earliestModel.authorization = payload.searchModel.authorization;
            }

            // parallelly make calls of provider schedule and earliest schedule.
            yield all([
                call(getSchedule, payload, payload.isMammogramSchedule),
                put({ type: types.OPEN_SCHEDULE_EARLIEST, searchModel: earliestModel, callback: payload.callbackOfEarliesSchedule })
            ]);
        }
        else {
            // only call provider schedule; do not call ealiest schedule.
            yield call(getSchedule, payload, payload.isMammogramSchedule);
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* getSchedule(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        // use a copy, since we're updating properties...
        const payloadWork = { ...payload };
        const allowStepForward = payload.searchModel.allowStepForward === undefined ? true : payload.searchModel.allowStepForward;    // allow client code to specifically disable the while loop below (default to true)

        try {
            let provider = yield call(getScheduleForProvider, payloadWork.searchModel, payload.isMammogramSchedule);
            let iCountdown = allowStepForward ? 5 : 0;
            //let iCountdown = 5;

            while ((provider.scheduleDays === null || provider.scheduleDays.length === 0) && iCountdown > 0 && !payload.isMammogramSchedule) {
                let dThisDate = Tools.toJSDate(payloadWork.searchModel.start, Tools.getDateFormats());
                let dNextDate = Tools.addMonths(dThisDate, 1);
                // set the start date to 1, since we're requesting a new month...
                dNextDate.setDate(1);
                let dNextEnd = Tools.addMonths(dNextDate, 1);
                dNextEnd = Tools.addDays(dNextEnd, -1);
                payloadWork.searchModel.start = Tools.dateSimpleFormat(dNextDate);
                payloadWork.searchModel.end = Tools.dateSimpleFormat(dNextEnd);
                provider = yield call(getScheduleForProvider, payloadWork.searchModel);
                iCountdown--;
            }

            //if (provider.scheduleDays === null || provider.scheduleDays.length === 0) {
            //    yield put({ type: types.OPEN_SCHEDULE_PROVIDER_FAILED });
            //}
            //else {
            yield put({ type: types.OPEN_SCHEDULE_PROVIDER_SUCCESS, provider, scheduleDaysAvailable: provider.scheduleDays !== null && provider.scheduleDays.length > 0 });
            //}

            if (payload.callback) {
                payload.callback(provider.scheduleDays, null, payload.searchModel.getEarliestSchedule, provider);
            }

            logAPI("MBHWeb.Saga.OpenScheduling.GetScheduleForProvider", start, null);
        }
        catch (error) {
            if (payload.callback) {
                payload.callback(null, error, payload.searchModel.getEarliestSchedule, null);
            }
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.GetScheduleForProvider.Failure", start, null, error);
            yield put({ type: types.OPEN_SCHEDULE_PROVIDER_FAILED });
            yield put({ type: types.AJAX_CALL_ERROR, error });
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleEarliestForProvider(payload) {
    console.log("earliestPayload", payload);
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const schedule = yield call(getEarliestScheduleForProvider, payload.searchModel);
            yield put({ type: types.OPEN_SCHEDULE_EARLIEST_SUCCESS, schedule });
            if (payload.callback) {
                payload.callback(schedule, null);
            }
            logAPI("MBHWeb.Saga.OpenScheduling.GetEarliestScheduleForProvider", start, null);
        }
        catch (error) {
            if (payload.callback) {
                payload.callback(null, error);
            }
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.GetEarliestScheduleForProvider.Failure", start, null, error);
            yield put({ type: types.OPEN_SCHEDULE_EARLIEST_FAILURE, error });
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleArrivalTimeForProvider(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const schedule = yield call(getArrivalTime, payload.searchModel);
            yield put({ type: types.OPEN_SCHEDULE_ARRIVAL_TIME_SUCCESS, schedule });
            if (payload.callback) {
                payload.callback(schedule, null);
            }
            logAPI("MBHWeb.Saga.OpenScheduling.GetArrivalTime", start, null);
        }
        catch (error) {
            if (payload.callback) {
                payload.callback(null, error);
            }
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.GetArrivalTime.Failure", start, null, error);
            yield put({ type: types.OPEN_SCHEDULE_ARRIVAL_TIME_FAILURE, error });
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleProviderList(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const providers = yield call(getProvidersList, payload.searchModel);

            yield all([
                put({ type: types.OPEN_SCHEDULE_PROVIDER_LIST_SUCCESS, providers })
            ]);
            logAPI("MBHWeb.Saga.OpenScheduling.GetProviderList", start, null);
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.GetProviderList.Failure", start, null, error);
            yield put({ type: types.AJAX_CALL_ERROR, error });
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleMonthly(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const schedule = yield call(getMonthlyAvailability, payload.searchModel);
            yield put({ type: types.OPEN_SCHEDULE_AVAILABILITY_SUCCESS, schedule });
            logAPI("MBHWeb.Saga.OpenScheduling.GetMonthlyAvailability", start, null);
        }
        catch (error) {
            console.error(error);
            logAPI("MBHWeb.Saga.OpenScheduling.GetMonthlyAvailability.Failure", start, null, error);
            yield put({ type: types.AJAX_CALL_ERROR, error });
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleSchedule(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        const scheduleCampaignReferrer = payload.model.scheduleCampaignReferrer;
        const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        try {
            yield put({ type: types.OPEN_SCHEDULE_SCHEDULE_PENDING });
            const schedule = yield call(scheduleAppointment, payload.model, payload.token, payload.isVaccineSearch, payload.isMammogramSchedule);
            // c'mon folks, check that 200 :)
            if (schedule.date) {
                yield put({ type: types.OPEN_SCHEDULE_SCHEDULE_SUCCESS, schedule });
                if (payload.callBack) {
                    payload.callBack(true, "");
                }
                logAPI("MBHWeb.Saga.OpenScheduling.ScheduleAppointment.Success", start, null, { response: schedule, ...scheduleCampaignActivity});
            }
            else {
                // only God and special people will know what the actual error message was
                throw schedule;
            }

        }
        catch (error) {          
            console.error(error);
            if (payload.callBack) {
                payload.callBack(false, error);
            }
            logAPI("MBHWeb.Saga.OpenScheduling.ScheduleAppointment.Failure", start, null, { error: error, ...scheduleCampaignActivity});
            yield put({ type: types.AJAX_CALL_ERROR, error });
            yield put({ type: types.OPEN_SCHEDULE_SCHEDULE_FAILED, error: error});
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleCreate(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            const patient = yield call(createPatient, payload.model, payload.token);
            yield put({ type: types.OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS, patient });
        }
        catch (error) {
            console.error(error);
            yield all([
                put({ type: types.OPEN_SCHEDULE_CREATE_PATIENT_FAILED }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}

export function* handleCreateAndSchedule(payload) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    if (stateData && stateData.epicEHRDown === false) {
        try {
            yield put({ type: types.OPEN_SCHEDULE_SCHEDULE_PENDING });

            const created = yield call(createPatient, payload.patient, payload.token);
            //We need to validate the ID before calling Schedule Appointement 
            if (created && created.ids) {
                logAPI("MBHWeb.Saga.OpenScheduling.CreateAndScheduleAppointment.Create", start, null);
                yield put({ type: types.OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS, patient: created });
                // add ids from createPatient to schedule...
                let ids = created.ids;
                let scheduleModel = payload.schedule;
                if (ids && ids.length > 0) {
                    let id = ids[0].id;
                    let idType = ids[0].type;

                    // per Utsab, prefer EPI, if present:
                    let epi = ids.filter(item => item.type === "EPI");
                    if (epi) {
                        id = epi[0].id;
                        idType = epi[0].type;
                    }

                    scheduleModel.proxyPatientId = id;
                    scheduleModel.proxyPatientIdType = idType;
                 
                    const schedule = yield call(scheduleAppointment, scheduleModel, payload.token, payload.isVaccineSearch, payload.isMammogramSchedule);
                    if (schedule.date) {
                        if (payload.callBack) {
                            payload.callBack(true, "");
                        }

                        yield all([
                            put({ type: types.OPEN_SCHEDULE_SCHEDULE_SUCCESS, schedule })
                        ]);
                        logAPI("MBHWeb.Saga.OpenScheduling.CreateAndScheduleAppointment.Schedule", start, null);
                    }
                    else {
                        throw new Error("Failed to schedule appointment."); // only God and special people know what the actual error message is.
                    }
                }
                else {
                    yield all([
                        put({ type: types.OPEN_SCHEDULE_CREATE_PATIENT_FAILED }),
                        put({ type: types.OPEN_SCHEDULE_SCHEDULE_FAILED }),
                        put({ type: types.AJAX_CALL_ERROR, created })
                    ]);
                    //debugger;
                    if (payload.callBack) {
                        payload.callBack(false, "Failed to create patient");
                    }
                }
            }
            else {
                logAPI("MBHWeb.Saga.OpenScheduling.CreateAndScheduleAppointment.Create.Failure", start, null);
                //error is not defined so change the value reference
                yield all([
                    put({ type: types.OPEN_SCHEDULE_CREATE_PATIENT_FAILED }),
                    put({ type: types.OPEN_SCHEDULE_SCHEDULE_FAILED }),
                    put({ type: types.AJAX_CALL_ERROR, created })
                ]);
                //debugger;
                if (payload.callBack) {
                    payload.callBack(false, "Failed to create patient");
                }
            }
        }
        catch (error) {
            console.error(error);
            //debugger;
            if (payload.callBack) {
                payload.callBack(false, error);
            }
            logAPI("MBHWeb.Saga.OpenScheduling.CreateAndScheduleAppointment.Schedule.Failure", start, null, error);
            yield all([
                put({ type: types.OPEN_SCHEDULE_SCHEDULE_FAILED }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
        }
    }
    else {
        console.log("openScheduingSaga: epicEHRDown");
    }
}
